import React from 'react'
import { SubmitErrorListener } from '@components/ui/SubmitErrorListener/SubmitErrorListener'
import { ClaimAcceptedListener } from '@components/ui/ClaimAcceptedListener'
import { AppContainer } from '../AppContainer/AppContainer'
import { AppWithConfigurationHOC, AppWithConfigurationProps } from './AppHOC'

const CtaContainer = React.lazy(() => import('@components/CTA/CtaContainer'))

export const DirectBillingApp: React.FC<AppWithConfigurationProps> = props => {
  const { customerContext: customer, actionModule, environment } = props
  return (
    <AppWithConfigurationHOC customerContext={customer} environment={environment} actionModule={actionModule}>
      <CtaContainer />
      <AppContainer />
      <ClaimAcceptedListener />
      <SubmitErrorListener />
    </AppWithConfigurationHOC>
  )
}
